import {
    adminGuideCategoriesControllerGetCategories,
    adminGuideCategoriesControllerCreateCategory,
    adminGuideCategoriesControllerUpdateCategory,
    adminGuideCategoriesControllerDeleteCategory,
} from "../api/generated";

// Migrated to the generated client. The server derives the company from the authed principal,
// so the endpoint has no `companyId` query param (the generated query type has none); the arg
// is kept for signature parity but not forwarded. Returns {data: GuideCategoryDto[]} so
// callers keep reading `res.data`.
export const getGuideCategories = async (companyId) => {
    const {data, error} = await adminGuideCategoriesControllerGetCategories();
    if (error) throw error;
    return {data};
};

// Migrated. The request body is {name, icon, imageUrl} — the server ignores any extra
// `companyId` the caller passes (and the generated body type rejects it), so we forward only
// the modeled fields.
export const saveGuideCategory = async (data) => {
    const {data: resData, error} = await adminGuideCategoriesControllerCreateCategory({
        body: {name: data.name, icon: data.icon, imageUrl: data.imageUrl},
    });
    if (error) throw error;
    return {data: resData};
};

export const updateGuideCategory = async (id, data) => {
    const {data: resData, error} = await adminGuideCategoriesControllerUpdateCategory({
        path: {id},
        body: {name: data.name, icon: data.icon, imageUrl: data.imageUrl},
    });
    if (error) throw error;
    return {data: resData};
};

export const deleteGuideCategory = async (id) => {
    const {data, error} = await adminGuideCategoriesControllerDeleteCategory({path: {id}});
    if (error) throw error;
    return {data};
};
